<template>
    <div class="carouselOuter" :class="{'transparent-bg' : widgets[0].blankBg}">
        <transition-group name="fade" mode="out-in">
            <carouselItem v-for="(widget, index) in widgets" :widget="widget" :key="`${widget.type}-${index}`" v-show="index === currentWidgetIndex" />
            </transition-group>
        <div class="stepsWrapper" v-if="numberOfWidgets>1">
            <div class="step" v-for="(step,index) in numberOfWidgets" :key="index" :class="{'active' : index === currentWidgetIndex}" @click="setStepIndex(index)"></div>
        </div>
    </div>
</template>

<script>
import carouselItem from '@/components/carouselItem.vue';

export default {
    name: 'HomepageCarousel',
    props: {
        widgets: {
            type: Array,
            required: true,
        },
    },
    components: { carouselItem },
    data () {
        return {
            currentWidgetIndex: 0,
        };
    },
    computed: {
        numberOfWidgets () {
            return this.widgets.length;
        },
    },
    methods: {
        setStepIndex (index) {
            this.currentWidgetIndex = index;
        },
    },
};
</script>

<style lang="scss" scoped>
.carouselOuter{
    background-color: rgba(255,255,255,.8);
    padding: 10px;
    border-radius: 6px;
    &.transparent-bg{
        background: transparent;
    }
    .stepsWrapper{
        display: flex;
            margin-top: 20px;
    justify-content: center;
        .step{
            cursor: pointer;
            height:12px;
            width:12px;
            border: 2px solid var(--primaryColour);
            background: white;
            border-radius:50%;
            margin: 0 5px;
            &.active{
                background: var(--primaryColour);
            }
        }
    }
}
</style>
